// extracted by mini-css-extract-plugin
export default {"container":"pill_container__34J_B","disabled":"pill_disabled__2o1gv","selected":"pill_selected__1hgNo","isDark":"pill_isDark__1s26g","isContrast":"pill_isContrast__dejyR"};